export const firebaseConfig = {
      apiKey: "AIzaSyDJU-UR0Xp1MGhMte59aWY-MotlX5FJ3vM",
      authDomain: "ctc-build-lp.firebaseapp.com",
      projectId: "ctc-build-lp",
      storageBucket: "ctc-build-lp.appspot.com",
      messagingSenderId: "726334089661",
      appId: "1:726334089661:web:9e8e922d61f71b28b18ad4"
}
